<template>
  <div class="login-page">
    <div class="login-bg">
      <span class="orb orb-1"></span>
      <span class="orb orb-2"></span>
      <span class="orb orb-3"></span>
    </div>

    <div class="login-shell">
      <section class="login-brand">
        <div class="brand-inner">
          <div class="brand-logo-wrap">
            <img :src="logoUrl" alt="欧小橙" class="brand-logo" />
          </div>
          <h1 class="brand-title">欧小橙代拍</h1>
          <p class="brand-subtitle">管理平台</p>
          <p class="brand-desc">卡牌代拍业务 · 订单运单 · 回款与合同一体化管理</p>
          <ul class="brand-features">
            <li><i class="el-icon-s-order"></i><span>订单与回款实时追踪</span></li>
            <li><i class="el-icon-truck"></i><span>快递签收与上拍进度</span></li>
            <li><i class="el-icon-document-checked"></i><span>合同签约与账户管理</span></li>
          </ul>
        </div>
      </section>

      <section class="login-panel">
        <div class="panel-card">
          <div class="panel-header">
            <h2>欢迎登录</h2>
            <p>请输入管理员账号和密码</p>
          </div>

          <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form" @submit.native.prevent>
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="用户名"
                prefix-icon="el-icon-user"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="密码"
                prefix-icon="el-icon-lock"
                show-password
                @keyup.enter.native="handleLogin"
              ></el-input>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button :loading="loading" type="primary" class="login-button" @click="handleLogin">
                {{ loading ? '登录中...' : '登 录' }}
              </el-button>
            </el-form-item>
          </el-form>

          <p class="panel-footer">© 欧小橙代拍 · 内部管理系统</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { login } from '@/api'

export default {
  name: 'Login',
  data() {
    return {
      logoUrl: require('@/static/logo.png'),
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const { data } = await login(this.loginForm)
          this.$store.dispatch('login', { token: data.token, userInfo: data.userInfo })
          this.$message.success('登录成功')
          this.$router.push('/')
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 45%, #334155 100%);
  overflow: hidden;
}

.login-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
}

.orb-1 {
  width: 420px;
  height: 420px;
  top: -120px;
  right: 10%;
  background: #ff6347;
}

.orb-2 {
  width: 320px;
  height: 320px;
  bottom: -80px;
  left: 8%;
  background: #ff8c00;
}

.orb-3 {
  width: 200px;
  height: 200px;
  top: 40%;
  left: 45%;
  background: #ffb347;
  opacity: 0.25;
}

.login-shell {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 980px;
  min-height: 560px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.login-brand {
  flex: 1.05;
  padding: 48px 40px;
  background: linear-gradient(160deg, rgba(255, 99, 71, 0.92) 0%, rgba(255, 140, 0, 0.88) 100%);
  color: #fff;
  display: flex;
  align-items: center;
}

.brand-inner {
  max-width: 360px;
}

.brand-logo-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  margin-bottom: 24px;
}

.brand-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.brand-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 1px;
}

.brand-subtitle {
  margin: 6px 0 0;
  font-size: 18px;
  opacity: 0.92;
  font-weight: 500;
}

.brand-desc {
  margin: 20px 0 28px;
  font-size: 14px;
  line-height: 1.7;
  opacity: 0.88;
}

.brand-features {
  list-style: none;
  margin: 0;
  padding: 0;
}

.brand-features li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-size: 14px;
  opacity: 0.95;
}

.brand-features i {
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.login-panel {
  flex: 0.95;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 36px;
}

.panel-card {
  width: 100%;
  max-width: 340px;
}

.panel-header h2 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
}

.panel-header p {
  margin: 8px 0 32px;
  font-size: 14px;
  color: #64748b;
}

.login-form {
  margin-top: 4px;
}

.submit-item {
  margin-bottom: 0;
  margin-top: 8px;
}

.login-button {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 2px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #ff6347, #ff8c00);
  box-shadow: 0 8px 20px rgba(255, 99, 71, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login-button:hover,
.login-button:focus {
  background: linear-gradient(90deg, #ff7259, #ff9a1a);
  box-shadow: 0 10px 24px rgba(255, 99, 71, 0.42);
}

.login-button:active {
  transform: translateY(1px);
}

.panel-footer {
  margin: 28px 0 0;
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
}

.login-form >>> .el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 10px;
  border-color: #e2e8f0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-form >>> .el-input__inner:focus {
  border-color: #ff8c00;
  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.15);
}

.login-form >>> .el-input__prefix {
  left: 12px;
  color: #94a3b8;
}

.login-form >>> .el-form-item {
  margin-bottom: 22px;
}

@media (max-width: 768px) {
  .login-shell {
    flex-direction: column;
    min-height: auto;
  }

  .login-brand {
    padding: 32px 28px;
  }

  .brand-features {
    display: none;
  }

  .login-panel {
    padding: 32px 24px 36px;
  }
}
</style>
